import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 36000000 // 请求超时时间36000秒=10小时
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  // 防止https跨域问题
  config.baseURL = config.baseURL.replace(/^https?:/, window.location.protocol)

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err', error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    if (error.response && error.response.data && error.response.data.message) {
      Message({
        message: error.response.data.message,
        type: 'error',
        duration: 3 * 1000
      })
    }
    return Promise.reject(error)
  }
)

// SSE 请求方法
function createSSERequest({ url, method = 'GET', headers = {}, body = null, onMessage, onError }) {
  url = process.env.BASE_API + url;
  headers['Authorization'] = getToken();
  headers['Connection'] = 'keep-alive';

  return new Promise((resolve, reject) => {
    if (method.toUpperCase() === 'GET') {
      const eventSource = new EventSource(url);

      eventSource.onmessage = (event) => {
        onMessage(JSON.parse(event.data));
      };

      eventSource.onerror = (error) => {
        if (onError) {
          onError(error);
        }
        eventSource.close();
        reject(error);
      };

      resolve({
        eventSource,
        close: () => {
          eventSource.close();
          clearInterval(intervalId);
        }
      });
    } else {
      fetch(url, {
        method,
        headers,
        body,
      })
        .then(response => {
          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let buffer = '';

          function processEvents() {
            const events = buffer.split('\n\n');
            buffer = events.pop(); // 保留最后一个未完成的事件

            for (const event of events) {
              if (event.trim()) {
                const lines = event.split('\n');
                for (const line of lines) {
                  if (line.startsWith('data:')) {
                    const data = line.slice(5).trim();
                    if (data) {
                      onMessage(JSON.parse(data));
                    }
                  }
                }
              }
            }
          }

          function read() {
            reader.read().then(({ done, value }) => {
              if (done) {
                buffer += decoder.decode(value); // 完成读取时解码剩余数据
                processEvents(); // 处理缓冲区中的剩余事件
                resolve(response);
                return;
              }

              buffer += decoder.decode(value, { stream: true });
              processEvents();
              read();
            }).catch(error => {
              if (onError) {
                onError(error);
              }
              reject(error);
            });
          }

          read();

          return {
            close: () => reader.cancel(),
          };
        })
        .catch(error => {
          if (onError) {
            onError(error);
          }
          reject(error);
        });
    }
  });
}

export default service
export { createSSERequest }



// WEBPACK FOOTER //
// ./src/utils/request.js